import React from "react";
import { View } from "react-native";
import { Ionicons } from "@expo/vector-icons";

import Colors from "../../Resources/Color";
import Tooltip from "../Components/Tooltip";
import { isPendingInvitationClient } from "./invitedClientUiGuards";

export const PENDING_INVITATION_INDICATOR_VARIANT = {
  SIDEBAR_CHIP: "sidebarChip",
  ICON_ONLY: "iconOnly",
};

export default function PendingInvitationIndicator({
  client,
  variant = PENDING_INVITATION_INDICATOR_VARIANT.SIDEBAR_CHIP,
}) {
  if (!isPendingInvitationClient(client)) {
    return null;
  }

  const isIconOnly =
    variant === PENDING_INVITATION_INDICATOR_VARIANT.ICON_ONLY;

  return (
    <Tooltip
      content="invitationPendingTooltip-string"
      placement="top"
      maxWidth={300}
    >
      {isIconOnly ? (
        <View
          style={{
            marginLeft: 6,
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <Ionicons
            name="mail-unread-outline"
            size={13}
            color={Colors.grayColor}
          />
        </View>
      ) : (
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            backgroundColor: "rgba(255, 255, 255, 0.08)",
            paddingHorizontal: 5,
            paddingVertical: 4,
            borderRadius: 6,
            marginLeft: 8,
            borderWidth: 0.5,
            borderColor: "rgba(255, 255, 255, 0.15)",
            position: "relative",
            flexShrink: 0,
          }}
        >
          <Ionicons
            name="mail-unread-outline"
            size={12}
            color={"rgba(255, 255, 255, 0.7)"}
          />
        </View>
      )}
    </Tooltip>
  );
}
